/**
 * @fileoverview Thumbnail constants. This is js so Cypress can access it.
 */
export const THUMBNAIL_AUTOPLAY_DELAY = 500;
